import actions from "../../constants/actions";

export const loadFaq = () => {
    return {
        type: actions.FAQ.LOAD,
        payload: {},
    };
};
